import { useMutation } from "react-query";
import http from "infra/http";
import { RequestAtualizarLancamentoMes } from "../typings";

function useAtualizarLancamentoMes(query: { id?: string; mes?: string }) {
  return useMutation(
    (data: RequestAtualizarLancamentoMes) => {
      return http.put(
        `/v1/previsao-orcamentaria/${query.id}/categoria/${data.categoriaFinanceiraId}/mes/${query.mes}`,
        data
      );
    },
    { retry: false }
  );
}

export default useAtualizarLancamentoMes;
